import { CONTENT_TYPE_HEADER_NAME, CSRF_FIELD_NAME, CSRF_HEADER_NAME, PAGE_NAME_FIELD_NAME } from './constants';
import { isFile } from '../../utility';

export const configWithCSRF = (config, csrf) => {
	let requestConfig = config || {};
	if (csrf) {
		requestConfig = {
			...requestConfig,
			headers: {
				[CSRF_HEADER_NAME]: csrf,
				...requestConfig?.headers
			}
		};
	}

	return requestConfig;
};

export const fileRequestConfig = config => {
	return {
		...config,
		headers: {
			...config?.headers,
			[CONTENT_TYPE_HEADER_NAME]: 'multipart/form-data'
		}
	};
};

export const formData = (pageName, data, config) => {
	const CSRF = data.get(CSRF_FIELD_NAME);
	if (CSRF) {
		data.delete(CSRF_FIELD_NAME);
	}
	if (data.get(PAGE_NAME_FIELD_NAME) !== pageName) {
		data.delete(PAGE_NAME_FIELD_NAME);
		data.append(PAGE_NAME_FIELD_NAME, pageName);
	}

	return {
		payload: data,
		requestConfig: configWithCSRF(config, CSRF)
	};
};

export const parseDataFile = (pageName, data, config) => {
	const parsedData = new FormData();
	for (const [key, value] of Object.entries(data)) {
		parsedData.append(key, value);
	}
	const { payload, requestConfig } = formData(pageName, parsedData, fileRequestConfig(config));
	return {
		payload,
		requestConfig
	};
};

export const queryString = (pageName, data, config) => {
	const { CSRF, ...rest } = data || {};
	const payload = new URLSearchParams({ ...rest, page_name: pageName });
	return {
		payload: payload.toString(),
		requestConfig: configWithCSRF(config, CSRF)
	};
};

export const requestFactory = (pageName, data, config) => {
	if (isFile(data)) {
		return parseDataFile(pageName, data, config);
	} else if (data instanceof FormData) {
		return formData(pageName, data, config);
	}

	return queryString(pageName, data, config);
};
